import React, { useState, useEffect } from 'react';
import './EmployeePosting.css';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { fetchLocations, getVerifiedEmployeesForPosting, postingEmployees } from '../../../services/employeePostingService';
import { getRoles, getUsers } from '../../../services/employeeCreationService';
import { getDistrict, getProject, getStates, getClients } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';

const EmployeePosting = () => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [employeeName, setEmployeeName] = useState(null);
  const [designation, setDesignation] = useState('');
  const [designationId, setDesignationId] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [employeeUniqueId, setEmployeeUniqueId] = useState('');
  const [fullName, setFullName] = useState('');
  const [education, setEducation] = useState('');
  const [experience, setExperience] = useState('');
  const [joiningDate, setJoiningDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [state, setPostingState] = useState(null);
  const [postingDistrict, setPostingDistrict] = useState(null);
  const [postingLocation, setPostingLocation] = useState(null);
  const [reportingTo, setReportingTo] = useState(null);
  const [role, setRole] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [subdivisionsOptions, setSubDivisionOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [reportingOptions, setReportingOptions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [blockOptions, setBlockOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [postingProjectCode, setPostingProjectCode] = useState(null);
  const [postingProject, setPostingProject] = useState(null);
  const [clientResponse, setClientResponse] = useState([]);
  const [clients, setClients] = useState(null);
  const [isFocused, setIsFocused] = useState({
    employeeName: false,
    joiningDate: false,
    state: false,
    postingDistrict: false,
    postingLocation: false,
    reportingTo: false,
    // role: false,
    fromDate: false,
    clients: false,
  });
  const [errors, setErrors] = useState({});
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [successMessage, setSuccessMessage] = useState(''); // New state for dynamic success message
  const [postingSubdivision, setPostingSubdivision] = useState(null);
  const [postingBlock, setPostingBlock] = useState(null);

  const fetchEmployees = async () => {
    try {
      const data = await getVerifiedEmployeesForPosting();
      console.log('API Response:', data);
      if (Array.isArray(data)) {
        setEmployees(
          data.map(item => ({
            value: item.id,
            label: `${item.fullName} - ${item.contactNumber}`,
            designation: item.designation,
            designationId: item.designationId,
            education: item.education,
            experience: `${item.yearsOfExperience} years`,
            employeeId: item.employeeId,
            employeeUniqueId: item.employeeUniqueId,
            fullName: item.fullName,
            joiningDate: item.joiningDate,
          }))
        );
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      setErrors(prev => ({ ...prev, general: 'Error fetching employees' }));
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const data = await getStates();
        setStateOptions(data.map(item => ({
          value: item.id,
          label: capitalizeFirstLetter(item.stateName),
        })));
      } catch (err) {
        console.error('Error fetching states:', err);
        setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
      }
    };

    // const fetchManagers = async () => {
    //   try {
    //     const data = await getUsers();
    //     setReportingOptions(data.map(item => ({
    //       value: item.employeeloginId,
    //       label: item.fullName,
    //     })));
    //   } catch (err) {
    //     console.error('Error fetching managers:', err);
    //     setErrors(prev => ({ ...prev, general: 'Failed to load reporting managers' }));
    //   }
    // };





    const fetchRoles = async () => {
      try {
        const data = await getRoles();
        setRoles(data.map(r => ({ value: r.roleId, label: r.roleName })));
      } catch (err) {
        console.error('Error fetching roles:', err);
        setErrors(prev => ({ ...prev, general: 'Failed to load roles' }));
      }
    };

    fetchEmployees();
    fetchStates();

    fetchRoles();
  }, []);
  const fetchManagers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/list/reporting/promotion?districtId=${postingDistrict}&designation=${designation}`);
      const data = response.data; // Extract the data from axios response

      // Check if data is an array
      if (Array.isArray(data) && data.length > 0) {
        setReportingOptions(data.map(item => ({
          value: item.employeeloginId,
          label: item.fullName,
        })));
      } else {
        setReportingOptions([]); // Set empty array if no data
        console.log('No reporting managers found');
      }
    } catch (err) {
      console.error('Error fetching managers:', err);
      setErrors(prev => ({ ...prev, general: 'Failed to load reporting managers' }));
    }
  };
  useEffect(() => {
    if (postingDistrict && designation) {  // Check if both are present
      fetchManagers();
    } else {
      setReportingOptions([]); // Clear options when dependencies are missing
      setReportingTo(null);
    }
  }, [designation, postingDistrict]);
  useEffect(() => {
    if (state) {
      const fetchClients = async () => {
        try {
          const data = await getClients(state);
          setClientResponse(
            data.map(client => ({
              value: client.id,
              label: client.clientName,
            }))
          );
        } catch (error) {
          console.error('Error fetching clients:', error);
          setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
        }
      };
      fetchClients();
    } else {
      setClientResponse([]);
      setClients(null);
      setProjectOptions([]);
      setPostingProject('');

      setEmployees([]);

    }
  }, [state]);

  useEffect(() => {
    if (state) {
      const fetchDistricts = async () => {
        try {
          const data = await getDistrict(state);
          setDistrictOptions(data.map(item => ({
            value: item.districtId,
            label: item.districtName,
          })));
        } catch (err) {
          console.error('Error fetching districts:', err);
          setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
        }
      };
      fetchDistricts();
    } else {
      setDistrictOptions([]);
      setPostingDistrict(null);
      setLocationOptions([]);
      setPostingLocation(null);
    }
  }, [state]);

  useEffect(() => {

    if (postingDistrict) {
      const fetchLocation = async () => {
        try {
          const data = await fetchLocations(postingDistrict, postingProject);
          setLocationOptions(data.map(item => ({
            value: item.id,
            label: item.name,
            type: item.type,
          })));
        } catch (err) {
          console.error('Error fetching locations:', err);
          setErrors(prev => ({ ...prev, general: 'Failed to load locations' }));
        }
      };
      fetchLocation();
    } else {
      setLocationOptions([]);
      setPostingLocation(null);
    }
  }, [postingDistrict]);


  useEffect(() => {
    if (clients) {
      const fetchProjects = async () => {
        try {
          const data = await getProject(clients);
          setProjectOptions(data.map(pro => ({
            value: pro.id,
            label: pro.projectCode,
            code: pro.projectCode,
          })));
        } catch (error) {
          console.error('Error fetching projects:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
        }
      };

      fetchProjects();
    } else {
      setProjectOptions([]); // Reset projects if no client is selected
    }
  }, [clients]);
  useEffect(() => {
    console.log("Posting project code:", postingProjectCode);
    if (postingProjectCode === 'CMR') {
      setIsMultiSelect(true);
    } else {
      setIsMultiSelect(false);
    }
  }, [postingProjectCode]);


  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption
      ? Array.isArray(selectedOption)
        ? selectedOption.map(opt => opt.value)
        : selectedOption.value
      : null;

    switch (field) {
      case 'employeeName':
        setEmployeeName(value);
        if (selectedOption) {
          setDesignation(selectedOption.designation);
          setDesignationId(selectedOption.designationId);
          setEmployeeId(selectedOption.employeeId);
          setEducation(selectedOption.education);
          setExperience(selectedOption.experience);
          setEmployeeUniqueId(selectedOption.employeeUniqueId || '');
          setFullName(selectedOption.fullName || '');
          setJoiningDate(selectedOption.joiningDate);
          console.log('Selected employeeUniqueId:', selectedOption.employeeUniqueId);
          console.log('Selected fullName:', selectedOption.fullName);
        } else {
          setDesignation('');
          setEmployeeId('');
          setEducation('');
          setExperience('');
          setEmployeeUniqueId('');
          setJoiningDate(null);
          setFullName('');
        }
        break;
      case 'postingLocation':
        if (postingProjectCode === 'CMR') {
          setPostingLocation(selectedOption ? selectedOption.map(opt => opt.value) : []);
        } else {
          setPostingLocation(selectedOption ? selectedOption.value : null);
        }
        break;
      case 'postingProject':
        setPostingProject(selectedOption ? selectedOption.value : null);
        setPostingProjectCode(selectedOption ? selectedOption.code : null);
        setPostingLocation(null);
        setPostingDistrict('');
        // setProjectOptions(null);
        break;
      case 'state':
        setPostingState(value);
        setPostingDistrict(null);
        setPostingLocation(null);
        break;
      case 'clients':
        setClients(value);
        // setProject(null);
        // setProjectResponse([]);
        // setEmployees([]);
        // setEmployeeData([]);
        break;
      case 'postingDistrict':
        setPostingDistrict(value);
        setPostingLocation(null);
        break;
      case 'postingSubdivision':
        setPostingSubdivision(value);
        setPostingLocation(null);
        break;
      case 'postingBlock':
        setPostingBlock(value);
        setPostingLocation(null);
        break;
      case 'reportingTo':
        setReportingTo(value);
        break;
      // case 'role':
      //   setRole(value);
      //   break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!employeeName) newErrors.employeeName = 'Employee Name is required';
    if (!employeeUniqueId) newErrors.employeeUniqueId = 'Employee Unique ID is required';
    if (!fullName) newErrors.fullName = 'Full Name is required';
    if (!state) newErrors.state = 'Posting State is required';
    if (!postingDistrict) newErrors.postingDistrict = 'Posting District is required';
    if (!postingLocation) newErrors.postingLocation = 'Posting Location is required';
    if (!reportingTo) newErrors.reportingTo = 'Reporting To is required';
    if (!joiningDate) newErrors.joiningDate = 'Joining Date is required';
    if (!fromDate) newErrors.fromDate = 'From Date is required';
    // if (!role) newErrors.role = 'Role is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClear = () => {
    setEmployeeName(null);
    setDesignation('');
    setEmployeeId('');
    setEducation('');
    setExperience('');
    setEmployeeUniqueId('');
    setFullName('');
    setFromDate(null);
    setJoiningDate(null);
    setPostingState(null);
    setPostingDistrict(null);
    setPostingLocation(null);
    setPostingProject(null);
    setPostingProjectCode(null);
    setReportingTo(null);
    setRole(null);
    // setClientResponse('');
    setClients('');
    setErrors({});
    setShowSuccessDialog(false);
    setSuccessMessage('');
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    // 1. Get the actual location objects for the selected IDs
    const selectedLocations = locationOptions.filter(opt =>
      Array.isArray(postingLocation)
        ? postingLocation.includes(opt.value)
        : opt.value === postingLocation
    );

    // 2. Check if the type is 'DHQ'
    // (Assuming if one is DHQ, we treat the selection as DHQ)
    const isDHQ = selectedLocations.some(loc => loc.type === 'DHQ');
    const locationIds = [...new Set(selectedLocations.map(loc => loc.value))];

    const payload = {
      employeeUniqueId: employeeUniqueId,
      employeeId: employeeId,
      designations: designationId,
      fullName,
      joiningDate: format(new Date(joiningDate), 'yyyy-MM-dd'),
      fromDate: format(fromDate, 'yyyy-MM-dd'),
      status: 'ACTIVE',
      postingState: state,
      postingDistrict,
      postingProject,
      reportingTo,
    };

    // 3. Conditional Keys for Payload
    if (isDHQ) {
      payload.workLocations = locationIds;
    } else {
      payload.godowns = locationIds;
    }

    // Add Audit Log
    const roleAudit = localStorage.getItem('role');
    const employeeIdAudit = localStorage.getItem('employeeId');
    if (employeeIdAudit && roleAudit) {
      payload.auditLog = getAuditLog();
    }

    console.log('Final Payload:', payload);

    try {
      await postingEmployees(payload);
      setSuccessMessage(`Employee ${fullName} posted successfully!`);
      setShowSuccessDialog(true);
      fetchEmployees();
    } catch (err) {
      setErrors(prev => ({ ...prev, general: 'Error saving employee posting' }));
    }
  };

  const handleDialogClose = () => {
    setShowSuccessDialog(false);
    handleClear();
    navigate('/dashboard');
  };

  return (
    <div className="employee-posting-maincontainer">
      <div className="employee-posting-box">
        <h2 className="employee-posting-heading">Employee Posting</h2>
        {errors.general && <div className="error-message">{errors.general}</div>}

        <div className="employee-posting-structure-heading">
          <div className="employee-posting-maincontainer-1">
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.employeeName || employeeName ? 'float-label' : ''}`}>
                <Select
                  name="employeeName"
                  options={employees}
                  value={employees.find(opt => opt.value === employeeName) || null}
                  onChange={option => handleInputChange(option, 'employeeName')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, employeeName: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, employeeName: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Employee Name
                </label>
                {errors.employeeName && <div className="error-message">{errors.employeeName}</div>}
                {errors.employeeUniqueId && <div className="error-message">{errors.employeeUniqueId}</div>}
                {errors.fullName && <div className="error-message">{errors.fullName}</div>}
              </div>
            </div>
            <div className="employee-posting-container-part">
              <div className="employee-posting-floating-label-container-2">
                <input
                  type="text"
                  name="designation"
                  value={designation}
                  readOnly
                  placeholder=" "
                  className="employee-posting-input"
                  disabled
                />
                <label>Designation</label>
              </div>
            </div>
          </div>

          <div className="employee-posting-maincontainer-1">
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.joiningDate || joiningDate ? 'float-label' : ''}`}>
                <DatePicker
                  selected={joiningDate ? new Date(joiningDate) : null}
                  onChange={date => {
                    setJoiningDate(date);
                    setErrors(prev => ({ ...prev, joiningDate: null }));
                  }}
                  dateFormat="dd-MM-yyyy"
                  placeholderText=" "
                  className="employee-posting-date-picker"
                  disabled
                />
                <label>

                  Onboarding Date
                </label>
                {errors.joiningDate && <div className="error-message">{errors.joiningDate}</div>}
              </div>
            </div>
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.state || state ? 'float-label' : ''}`}>
                <Select
                  name="state"
                  options={stateOptions}
                  value={stateOptions.find(opt => opt.value === state) || null}
                  onChange={option => handleInputChange(option, 'state')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Posting State
                </label>
                {errors.state && <div className="error-message">{errors.state}</div>}
              </div>
            </div>
          </div>

          <div className="employee-posting-maincontainer-1">
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.clients || clients ? 'float-label' : ''}`}>
                <Select
                  name="clients"
                  options={clientResponse}
                  value={clientResponse.find(opt => opt.value === clients) || null}
                  onChange={option => handleInputChange(option, 'clients')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label> <span className="required">*</span>Client</label>
                {errors.clients && <div className="error-message">{errors.clients}</div>}
              </div>

            </div>
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.postingProject || postingProject ? 'float-label' : ''}`}>
                <Select
                  name="postingProject"
                  options={projectOptions}
                  value={projectOptions.find(opt => opt.value === postingProject) || null}
                  onChange={option => handleInputChange(option, 'postingProject')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, postingProject: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, postingProject: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Project
                </label>
                {errors.postingProject && <div className="error-message">{errors.postingProject}</div>}
              </div>

            </div>
          </div>

          <div className="employee-posting-maincontainer-1">
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.postingDistrict || postingDistrict ? 'float-label' : ''}`}>
                <Select
                  name="postingDistrict"
                  options={districtOptions}
                  value={districtOptions.find(opt => opt.value === postingDistrict) || null}
                  onChange={option => handleInputChange(option, 'postingDistrict')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, postingDistrict: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, postingDistrict: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Posting District
                </label>
                {errors.postingDistrict && <div className="error-message">{errors.postingDistrict}</div>}
              </div>



            </div>
            <div className="employee-posting-container-part">
              {/* <div className={`employee-posting-floating-label-container-2 ${isFocused.role || role ? 'float-label' : ''}`}>
                <Select
                  name="role"
                  options={roles}
                  value={roles.find(opt => opt.value === role) || null}
                  onChange={option => handleInputChange(option, 'role')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, role: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, role: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Role
                </label>
                {errors.role && <div className="error-message">{errors.role}</div>}
              </div> */}
              <div
                className={`employee-posting-floating-label-container-2 ${isFocused.postingLocation || (Array.isArray(postingLocation) ? postingLocation.length > 0 : postingLocation)
                  ? 'float-label'
                  : ''
                  }`}
              >
                <Select
                  name="postingLocation"
                  options={locationOptions}
                  classNamePrefix="posting-godown"
                  value={
                    postingProjectCode === 'CMR'
                      ? locationOptions.filter(opt => postingLocation?.includes(opt.value))
                      : locationOptions.find(opt => opt.value === postingLocation) || null
                  }
                  onChange={option => handleInputChange(option, 'postingLocation')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, postingLocation: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, postingLocation: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                  isMulti={postingProjectCode === 'CMR'}
                  closeMenuOnSelect={postingProjectCode !== 'CMR'}
                />
                <label>
                  <span className="required">*</span>Working Location
                </label>
                {errors.postingLocation && <div className="error-message">{errors.postingLocation}</div>}
              </div>
            </div>
          </div>

          <div className="employee-posting-maincontainer-1">
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.reportingTo || reportingTo ? 'float-label' : ''}`}>
                <Select
                  name="reportingTo"
                  options={reportingOptions}
                  value={reportingOptions.find(opt => opt.value === reportingTo) || null}
                  onChange={option => handleInputChange(option, 'reportingTo')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, reportingTo: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, reportingTo: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Reporting To
                </label>
                {errors.reportingTo && <div className="error-message">{errors.reportingTo}</div>}
              </div>
            </div>
            <div className="employee-posting-container-part">
              <div className={`employee-posting-floating-label-container-2 ${isFocused.fromDate || fromDate ? 'float-label' : ''}`}>
                <DatePicker
                  selected={fromDate}
                  onChange={date => {
                    setFromDate(date);
                    setErrors(prev => ({ ...prev, fromDate: null }));
                  }}
                  onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                  dateFormat="dd-MM-yyyy"
                  placeholderText=" "
                  className="employee-posting-date-picker"
                  minDate={joiningDate ? new Date(joiningDate) : null}
                />
                <label>
                  <span className="required">*</span>Reporting Date
                </label>
                {errors.fromDate && <div className="error-message">{errors.fromDate}</div>}
              </div>
            </div>
          </div>

          <div className="employee-posting-btn-div">
            <button type="button" className="employee-posting-cancel" onClick={() => navigate('/dashboard')}>
              Cancel
            </button>
            <button type="button" className="employee-posting-clear" onClick={handleClear}>
              Clear
            </button>
            <button
              type="button"
              className="employee-posting-btn"
              onClick={handleSave}
              disabled={
                !employeeName ||
                !employeeUniqueId ||
                !fullName ||
                !state ||
                !postingDistrict ||
                !postingLocation ||
                !reportingTo ||
                !joiningDate ||
                // !role ||
                !fromDate
              }
            >
              Save
            </button>
          </div>
        </div>

        {showSuccessDialog && (
          <div className="custom-modal-overlay-att">
            <div className="custom-modal-att">
              <h3>Employee Posting</h3>
              <p>{successMessage}</p>
              <button
                type="button"
                className="employee-posting-dialog-btn"
                onClick={handleDialogClose}
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeePosting;